import { useTranslation } from 'react-i18next'

import { FormikWysiwygField } from '../../../../Formik'
import { CHAT_FORM_FIELD_NAME_MESSAGE } from '../../ChatForm.constants'

function MessageField({ onInit }) {
  const { t } = useTranslation()

  return (
    <FormikWysiwygField
      enablePasteAutolink
      fieldComponentProps={{
        label: `${t('Chat.MessageLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      name={CHAT_FORM_FIELD_NAME_MESSAGE}
      placeholder={t('Chat.MessagePlaceholderKey')}
      onInit={onInit}
    />
  )
}

export default MessageField
